import { CustomElement } from '@aurelia/runtime-html';
export const name = "checkbox-advanced-component";
export const template = "<div class=\"w-full flex flex-col gap-3\">\n  <div class=\"w-full mx-auto grid grid-cols-1 pl-4 gap-4 justify-center items-center\">\n    <label repeat.for=\"option of options\" for=\"${id + '-' + option.value}\"\n      class=\"w-fit flex items-center justify-start gap-3 cursor-pointer\">\n      <input ...$attrs id=\"${id + '-' + option.value}\" type=\"checkbox\" model.bind=\"option.value\"\n        checked.bind=\"selectedValues\" disabled.bind=\"disabled\" class=\"peer checkbox-input\" />\n      <span class=\"checkbox-label\">${option.label}</span>\n    </label>\n  </div>\n</div>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
